import { Tab } from '@headlessui/react';
import { Login, Register } from 'components/integrations/shopify';
import { LayoutPublic } from 'components/layout';
import { usePageTitle } from 'utils';

export default function ShopifyWelcome() {
  usePageTitle('Welcome | Segments');

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <LayoutPublic>
      <div className="w-full max-w-md px-2 py-16 mx-auto sm:px-0">
        <div className="lg:flex lg:justify-center lg:mt-6">
          <div className="flex items-center space-x-2">
            <img
              width="64"
              height="64"
              src="/assets/logo-segments.png"
              alt="logo"
              className="w-6 h-6 lg:h-16 lg:w-16"
            />
            <p className="tracking-segments-logo text-segments-dark lg:text-[32px]">
              Segments
            </p>
          </div>
        </div>
        <div className="mt-10">
          <Tab.Group defaultIndex={1}>
            <Tab.List className="flex p-1 space-x-1 rounded-xl bg-segments-gray-F1">
              {['Login', 'Register'].map((item) => (
                <Tab
                  key={item}
                  className={({ selected }) =>
                    classNames(
                      'w-full py-2.5 text-sm leading-5 font-medium rounded-lg',
                      'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60',
                      selected
                        ? 'bg-segments-accent-color-1 shadow text-white'
                        : 'hover:bg-white/[0.12] hover:text-segments-link'
                    )
                  }
                >
                  {item}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels className="mt-2">
              <Tab.Panel
                className={classNames(
                  'bg-white rounded-xl p-3',
                  'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60'
                )}
              >
                <Login />
              </Tab.Panel>
              <Tab.Panel
                className={classNames(
                  'bg-white rounded-xl p-3',
                  'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60'
                )}
              >
                <Register />
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    </LayoutPublic>
  );
}
